module.exports = __webpack_public_path__ + "img/IR.192efe1b.png";